import React, { useRef, useState, useEffect } from "react";
import { Typeahead } from "react-bootstrap-typeahead";

import "react-bootstrap-typeahead/css/Typeahead.css";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import {
  getCity,
  GetCourses,
  GetSkill,
  getUniversity,
  selectSector,
  addNotification,
} from "../Actions/CommonAction";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { token, roleid } from "../Actions/AuthAction";
import { getEmployerList, getUniversityList } from "../Actions/AdminAction";
import { postJob } from "../Actions/JobAction";
import { useHistory } from "react-router";
import Swal from "sweetalert2";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};
export const AddJob = (props) => {
  const history = useHistory();

  const [employerOptions, setemployerOptions] = useState([]);
  const [universityOption, setuniversityOption] = useState([]);
  const [courseOptions, setcourseOptions] = useState(null);
  const [locOptions, setlocOptions] = useState([]);
  const form = useRef(null);
  const [skillOptions, setskillOptions] = useState(null);
  const [sectorOptions, setsectorOptions] = useState(null);

  const [courses, setCourses] = useState([]);
  const [skills, setSkills] = useState([]);
  const [min, setmin] = useState(null);
  const [max, setmax] = useState(null);
  const [jobLocation, setjobLocation] = useState([]);
  const [yearOfPassing, setyearOfPassing] = useState([]);
  const [employerid, setemployerid] = useState(null);
  const [sector, setsector] = useState(null);
  const [jobtype, setjobtype] = useState(null);
  const [payroll, setpayroll] = useState("Company Payroll");
  const [jobdesignation, setjobdesignation] = useState(null);
  const [jobdescription, setjobdescription] = useState(null);
  const [keyresponsibility, setkeyresponsibility] = useState(null);
  const [typeofplacement, settypeofplacement] = useState(null);
  const [perksandbenefits, setperksandbenefits] = useState(null);
  const [trainingperiod, settrainingperiod] = useState(null);
  const [bonddetails, setbonddetails] = useState(null);
  const [noofvacancy, setnoofvacancy] = useState(null);
  const [specialrequirement, setspecialrequirement] = useState(null);
  const [min10th, setmin10th] = useState(0);
  const [min12th, setmin12th] = useState(0);
  const [mingrad, setmingrad] = useState(0);
  const [minpostgrad, setminpostgrad] = useState(0);
  const [registeredlink, setregisteredlink] = useState("");
  const [universitydetails, setuniversitydetails] = useState([]);

  useEffect(() => {
    GetData();
    if (props.edit === true) {
      setjobdata(props.jobDetails);
    }
  }, []);

  const setjobdata = (data) => {
    let dataCourse = [];
    let dataLocation = [];

    data.university.map((item, index) => {
      data.university[index].name = item.university.university_name;
      data.university[index].id = item.university.id;
    });
    setuniversitydetails(data.university);
    data.jobskillmap.map(
      (item, index) =>
        (data.jobskillmap[index].name = item.skillcode0.skillname)
    );
    setSkills(data.jobskillmap);
    // const [universitydetails, setuniversitydetails] = useState([])
    // const [skills, setSkills] = useState([]);
    setsector(data.sector.id);
    data.joblocationmaps.map((item) => dataLocation.push(item.city));

    setjobLocation(dataLocation);
    data.jobcoursemaps.map((item) => dataCourse.push(item.course));
    setCourses(dataCourse);
    setemployerid(data.employeeid);
    setpayroll(data.payroll);
    //employer ,university,
    setmin(data.costtocompanystart);
    setmax(data.costtocompanyend);

    setyearOfPassing(data.yearofpassing.split(","));
    setjobtype(data.jobtype);
    setjobdesignation(data.jobdesignation);
    setjobdescription(data.jobdescription);
    setkeyresponsibility(data.keyresponsibility);
    settypeofplacement(data.typeofplacement);
    setperksandbenefits(data.perksandbenefits);
    settrainingperiod(data.trainingperiod);
    setbonddetails(data.bonddetails);
    setnoofvacancy(data.noofvacancy);
    setspecialrequirement(data.specialrequirement);
    setmin10th(data.min10th);
    setmin12th(data.min12th);
    setmingrad(data.mingrad);
    setminpostgrad(data.minpostgrad);
    setregisteredlink(data.registeredlink);
  };

  const submitDetails = (e) => {
    const jobDetails = {
      loginusertoken: token(),
      employerid: employerid,
      payrolltype: payroll,
      sector: sector,
      jobtype: jobtype,
      jobdesignation: jobdesignation,
      jobdescription: jobdescription,
      joblocation: [],
      keyresponsibility: keyresponsibility,
      typeofplacement: typeofplacement,
      minSalary: min,
      maxSalary: max,
      perksandbenefits: perksandbenefits,
      trainingperiod: trainingperiod,
      bonddetails: bonddetails,
      noofvacancy: noofvacancy,
      courseids: [],
      skill: [],
      specialrequirement: specialrequirement,
      yearofpassing: yearOfPassing,
      min10th: min10th,
      min12th: min12th,
      mingrad: mingrad,
      minpostgrad: minpostgrad,
      registeredlink: registeredlink,
      universityid: [],
    };

    e.preventDefault();
    form.current.validateAll();
    jobLocation.map(
      (item, index) => (jobDetails.joblocation[index] = item.district_id)
    );
    skills.map((item, index) => (jobDetails.skill[index] = item.skillcode));
    courses.map((item, index) => (jobDetails.courseids[index] = item.id));
    universitydetails.map(
      (item, index) => (jobDetails.universityid[index] = item.id)
    );
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't save`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        if (validateForm(jobDetails)) {
          if (props.edit) {
            jobDetails.jobid = props.jobDetails.jobid;
          }
          postJob(jobDetails).then((res) => {
            if (res.error) {
              // alert(res.error);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: res.error,
              });
              console.log(res.error);
            } else {
              const replaceData = document.getElementById("replaceData");
              const element = document.getElementById("success");
              replaceData.innerText = "Your job has been posted.";
              element.classList.add("show");
              element.style.display = "block";
              element.style.backgroundColor = "#00000057";

              //notication
              universitydetails.map((item, index) => {
                const notimodel = {
                  loginusertoken: token(),
                  modulecode: roleid(),
                  notificationtitle: "Add New Job",
                  description: "Add new Job please check the job",
                  userid: item.id,
                  usertype: 6,
                };
                addNotification(notimodel).then((resnoti) => { });
              });

              const notimodel = {
                loginusertoken: token(),
                modulecode: roleid(),
                notificationtitle: "Add New Job",
                description: "Add new Job please check the job",
                userid: employerid,
                usertype: 4,
              };
              addNotification(notimodel).then((resnoti) => { });
              //end notification

              // alert()
              Swal.fire("Job has been posted!", "", "success");
              history.push("/listjob");
            }
          });
        } else {
          const replaceData = document.getElementById("replaceData");
          replaceData.innerText = "Kindly fill all the provided fields.";
          const element = document.getElementById("success");
          element.classList.add("show");
          element.style.display = "block";
          element.style.backgroundColor = "#00000057";
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  const validateForm = (jobDetails) => {
    let ret = true;
    Object.keys(jobDetails).map((key, index) => {
      if (jobDetails[key] === null) {
        ret = false;
      }
    });
    return ret;
  };
  const removeModal = () => {
    const element = document.getElementById("success");
    element.classList.remove("show");
  };
  const GetData = () => {
    GetCourses({ status: 1 }).then((res) => setcourseOptions(res.data));
    GetSkill({ status: "true" }).then((res) => {
      res.data.map((item, index) => (res.data[index].name = item.skillname));
      setskillOptions(res.data);
    });
    selectSector({ status: "true" }).then((res) => setsectorOptions(res.data));
    getCity().then((res) => setlocOptions(res.data));
    getEmployerList({
      page: "-1",
      search: "",
      status: 1,
      city: "",
      state: "",
      limit: "",
    }).then((res) => setemployerOptions(res.data));
    getUniversity({
      page: "-1",
      key: token(),
      search: "",
      status: 1,
      city: "",
      state: "",
      limit: "",
    }).then((res) => {
      res.data.map((item, index) => {
        res.data[index].id = item.university.id;
        res.data[index].name = item.university.university_name;
      });
      console.log(res.data);
      setuniversityOption(res.data);
    });
    // setuniversityOption(res.data)
  };
  const date = new Date();

  const jobtypeoptions = ["Part Time", "Full Time", "Intern", "Others"];
  const yearOfPassingOption = [];
  const traingPeriodOptions = [];
  const minPercentageOptions = [];

  for (let i = 0; i < 37; i++) {
    yearOfPassingOption.push(`${date.getFullYear() - i + 1}`);
    traingPeriodOptions.push(i);
  }
  for (let i = 50; i < 95; i += 5) {
    minPercentageOptions.push(i);
  }

  return (
    <React.Fragment>
      <div>
        <div className="row mb-4">
          <div className="col-md-12">
            <h4 className="table_heading position-relative">JOB ADD</h4>
          </div>
        </div>
        <div className="card formcard">
          <div className="card-body">
            <div className="card-header1">Professional Detail</div>
            <Form onSubmit={submitDetails} ref={form}>
              <div className="row">
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputEmailAddress">
                    Job Designation
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    className="form-control rounded-pill"
                    value={jobdesignation}
                    onChange={(e) => setjobdesignation(e.target.value)}
                  />
                </div>
                {props.edit != true && (
                  <div className="form-group col-md-12">
                    <label className="small mb-1" for="inputEmailAddress">
                      Employer
                      <span className="text-danger font-weight-bold">*</span>
                    </label>
                    <Select
                      title="Select Company"
                      validations={[required]}
                      className="form-control rounded-pill"
                      onChange={(e) => setemployerid(e.target.value)}
                    >
                      <option hidden>Select Company</option>
                      {employerOptions.map((item) => (
                        <option
                          value={item.id}
                          style={{ backgroundImage: `url(${item.logo})` }}
                        >
                          {item.companyname}
                        </option>
                      ))}
                    </Select>
                  </div>
                )}
                {props.edit != true && (
                  <div className="form-group col-md-12">
                    <label className="small mb-1" for="inputEmailAddress">
                      University
                      <span className="text-danger font-weight-bold">*</span>
                    </label>
                    <Typeahead
                      validations={[required]}
                      className="rounded-pill "
                      id="basic-typeahead-multiple"
                      labelKey="name"
                      multiple
                      onChange={setuniversitydetails}
                      options={universityOption}
                      placeholder="Choose several University..."
                      selected={universitydetails}
                    />
                  </div>
                )}

                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputEmailAddress">
                    Company Payroll
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    type="radio"
                    name="payroll"
                    validations={[required]}
                    className="form-control rounded-pill"
                    value="Company Payroll"
                    onChange={(e) => setpayroll(e.target.value)}
                    checked
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputEmailAddress">
                    Rozgar Payroll
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    type="radio"
                    name="payroll"
                    validations={[required]}
                    className="form-control rounded-pill"
                    value="Rozgar Payroll"
                    onChange={(e) => setpayroll(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputEmailAddress">
                    Job Sector
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Select
                    validations={[required]}
                    className="form-control rounded-pill"
                    value={sector}
                    onChange={(e) => setsector(e.target.value)}
                  >
                    <option hidden>Select Sector</option>
                    {sectorOptions == null ? (
                      <option>Loading...</option>
                    ) : (
                      sectorOptions.map((item) => (
                        <option value={item.id}>{item.sectorname}</option>
                      ))
                    )}
                  </Select>
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputEmailAddress">
                    Job Type
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Select
                    validations={[required]}
                    className="form-control rounded-pill"
                    value={jobtype}
                    onChange={(e) => setjobtype(e.target.value)}
                  >
                    <option hidden>Select Job Type</option>
                    {jobtypeoptions.map((item) => (
                      <option value={item}>{item}</option>
                    ))}
                  </Select>
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Job Location
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Typeahead
                    validations={[required]}
                    className="rounded-pill "
                    id="basic-typeahead-multiple"
                    labelKey="name"
                    multiple
                    onChange={setjobLocation}
                    options={locOptions}
                    placeholder="Choose several states..."
                    selected={jobLocation}
                  />{" "}
                </div>
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputPassword">
                    Job Description
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={jobdescription}
                    onChange={(e) => setjobdescription(e)}
                  />
                </div>
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputPassword">
                    Key Responsibilities
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={keyresponsibility}
                    onChange={(e) => setkeyresponsibility(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Drive Medium
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  {/* <Input validations={[required]} className="form-control rounded-pill" id="inputPassword" type="text"
                                             /> */}
                  <Select
                    validations={[required]}
                    className="form-control rounded-pill"
                    value={typeofplacement}
                    onChange={(e) => settypeofplacement(e.target.value)}
                  >
                    <option hidden>Select Drive Medium</option>
                    <option value="Virtual Campus Drive">
                      Virtual Campus Drive
                    </option>
                    <option value="On Campus Drive">On Campus Drive</option>
                    <option value="Off Campus Drive">Off Campus Drive</option>
                    <option value="Others">Others</option>
                  </Select>
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Registeration Link
                  </label>
                  <Input
                    validations={[required]}
                    className="form-control rounded-pill"
                    id="inputPassword"
                    type="text"
                    value={registeredlink}
                    onChange={(e) => setregisteredlink(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputPassword">
                    CTC(Cost to Company in LPA)
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                </div>
                <div className="form-group col-md-6">
                  <label>
                    Minimum Value
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    value={min}
                    className="form-control rounded-pill"
                    id="inputPassword"
                    type="number"
                    min={0}
                    max={100000000}
                    onChange={(e) => setmin(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>
                    Maximum Value
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    value={max}
                    className="form-control rounded-pill"
                    id="inputPassword"
                    type="number"
                    min={0}
                    max={100000000}
                    onChange={(e) => setmax(e.target.value)}
                  />
                </div>

                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputPassword">
                    Perks And Benefits
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={perksandbenefits}
                    onChange={(e) => setperksandbenefits(e)}
                  />
                </div>
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputPassword">
                    Special Requirement
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={specialrequirement}
                    onChange={(e) => setspecialrequirement(e)}
                  />
                </div>
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputPassword">
                    Bond Details
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={bonddetails}
                    onChange={(e) => setbonddetails(e)}
                  />
                </div>

                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    No. Of Vacancy
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    className="form-control rounded-pill"
                    id="inputPassword"
                    type="number"
                    value={noofvacancy}
                    onChange={(e) => setnoofvacancy(e.target.value)}
                    min={1}
                    placeholder="Label"
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Training Period
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Select
                    validations={[required]}
                    className="form-control rounded-pill"
                    value={trainingperiod}
                    onChange={(e) => settrainingperiod(e.target.value)}
                  >
                    <option hidden>Select Training Period</option>

                    {traingPeriodOptions.map((item) => (
                      <option value={item}>{item} Month</option>
                    ))}
                  </Select>
                </div>
                <div className="card-header1 col-md-12">
                  Qualification Detail
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Course
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Typeahead
                    validations={[required]}
                    className="rounded-pill "
                    id="Courses"
                    labelKey="name"
                    multiple
                    onChange={setCourses}
                    options={courseOptions}
                    placeholder="Choose Courses ..."
                    selected={courses}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Skills
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Typeahead
                    validations={[required]}
                    className="rounded-pill "
                    id="Skills"
                    labelKey="name"
                    multiple
                    onChange={setSkills}
                    options={skillOptions}
                    placeholder="Choose skill ..."
                    selected={skills}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Year Of Passing
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Typeahead
                    validations={[required]}
                    className="rounded-pill "
                    id="PassingYear"
                    labelKey="name"
                    multiple
                    onChange={setyearOfPassing}
                    options={yearOfPassingOption}
                    placeholder="Passing Year ..."
                    selected={yearOfPassing}
                  />{" "}
                  {/* <Select validations={[required]} className="form-control rounded-pill" onChange={(e) => jobDetails.yearOfPassing = e.target.value}>
                                    <option hidden>Select Year of Passing</option>

                                    {yearOfPassingOption.map((items) => <option value={items}>{items}</option>)}


                                </Select> */}
                </div>

                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    10th Percentage
                  </label>
                  <Select
                    className="form-control rounded-pill"
                    value={min10th}
                    onChange={(e) => setmin10th(e.target.value)}
                  >
                    <option selected={true} value={0}>
                      Select
                    </option>
                    {minPercentageOptions.map((item) => (
                      <option value={item}>{item}%</option>
                    ))}
                  </Select>
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    12th Percentage
                  </label>
                  <Select
                    className="form-control rounded-pill"
                    value={min12th}
                    onChange={(e) => setmin12th(e.target.value)}
                  >
                    <option selected={true} value={0}>
                      Select
                    </option>
                    {minPercentageOptions.map((item) => (
                      <option value={item}>{item}%</option>
                    ))}
                  </Select>
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Graduation Percentage
                  </label>
                  <Select
                    className="form-control rounded-pill"
                    value={mingrad}
                    onChange={(e) => setmingrad(e.target.value)}
                  >
                    <option selected={true} value={0}>
                      Select
                    </option>
                    {minPercentageOptions.map((item) => (
                      <option value={item}>{item}%</option>
                    ))}
                  </Select>
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputPassword">
                    Post-Graduation Percentage
                  </label>
                  <Select
                    className="form-control rounded-pill"
                    value={minpostgrad}
                    onChange={(e) => setminpostgrad(e.target.value)}
                  >
                    <option selected={true} value={0}>
                      Select
                    </option>
                    {minPercentageOptions.map((item) => (
                      <option value={item}>{item}%</option>
                    ))}
                  </Select>
                </div>

                {/* <div className="form-group col-md-6 d-flex justify-content-start align-items-center">
                                        <div className="d-flex justify-content-start">
                                        <Input validations={[required]} type="file" id="upload" hidden/>
                                        <label for="upload" className="uploadfile"><i className="fa fa-upload" aria-hidden="true"></i> Choose file <span className="text-danger font-weight-bold">*</span></label>
                                        <p className="mt-2 ml-2">File Name</p>
                                    </div>
                                    </div> */}
                <div className="form-group col-md-12 mt-4 mb-0">
                  <button className="btn btn-primary-custom mx-2" type="submit">
                    Submit
                  </button>
                  <a
                    className="btn btn-secondary-custom mx-2"
                    href="#"
                    onClick={() => (props.edit ? props.setedit(false) : null)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="success"
        data-backdrop="static"
        data-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Modal title
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={removeModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" id="replaceData">
              Your job has been posted.
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={removeModal}
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Understood
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
